export default __webpack_public_path__ + "static/media/arrows.ff327b14.png";